import React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons";
import {
  AnalyticsContext,
  CreateCustomFlashpackCellTapEvent,
} from "../../common/context/AnalyticsContext";
import { FlashpackType } from "../../common/api";
import { CELL_COVER_SIZE, clampLines } from "../../common/CommonStyles";
import { COLOR_TEXT_PRIMARY } from "../../common/colors";
import { SURFACE_CARD_RADIUS } from "../../common/constants";
import { SPACE_XS, SPACE_LG } from "../../common/spacing";
import { elevation1Clipped } from "../../common/elevation";

const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

const Cover = styled.div`
  width: ${CELL_COVER_SIZE}px;
  height: ${CELL_COVER_SIZE}px;
  flex-shrink: 0;
  margin-right: ${SPACE_LG}px;
  border-radius: ${SURFACE_CARD_RADIUS}px;
  overflow: hidden;
  ${elevation1Clipped}

  & img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const MetadataBody = styled.div`
  flex: 1;
  min-width: 0;
  height: ${CELL_COVER_SIZE}px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Title = styled.div`
  ${clampLines(1)}
  display: flex;
  align-items: center;
  gap: ${SPACE_XS}px;
  color: ${COLOR_TEXT_PRIMARY};
  font-weight: 500;
  font-size: 16px;
`;

export const CreateFlashpackItem = ({
  flashpackType,
}: {
  flashpackType: FlashpackType;
}) => {
  const { t } = useTranslation();
  const { logEvent } = React.useContext(AnalyticsContext);
  return (
    <Link
      to={{
        pathname: "/lessons/create-flashpack/",
        state: { flashpackType: flashpackType },
      }}
      style={{ textDecoration: "none" }}
      onClick={() => {
        logEvent(new CreateCustomFlashpackCellTapEvent(flashpackType));
      }}
    >
      <Row>
        <Cover>
          <img
            src={`${process.env.PUBLIC_URL}/custom-flashpack-cover.png`}
            alt={t("flashpacks_create_flashpack")}
          />
        </Cover>
        <MetadataBody>
          <Title>
            <FontAwesomeIcon icon={faPlusCircle} />
            {t("flashpacks_create_flashpack")}
          </Title>
        </MetadataBody>
      </Row>
    </Link>
  );
};
